import {
  Box,
  CircularProgress,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';
import type { MiseSeller } from '@/lib/types/mise/seller';

interface SellerListProps {
  sellers: MiseSeller[] | undefined;
  isLoading: boolean;
  error: Error | null;
  title?: string; // オプショナルに変更
}

/**
 * 店舗一覧を表示するコンポーネント
 */
export function SellerList({ sellers, isLoading, error, title }: SellerListProps) {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>読み込み中...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        {error instanceof Error ? error.message : '店舗一覧の読み込みに失敗しました。'}
      </Alert>
    );
  }

  if (!sellers || sellers.length === 0) {
    return (
      <Alert severity="info" sx={{ mt: 2 }}>
        店舗が登録されていません。
      </Alert>
    );
  }

  return (
    <Box sx={{ mt: 2 }}>
      {title && (
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: 'text.primary' }}>
          {title}
        </Typography>
      )}
      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>店舗ID</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>店舗名</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sellers.map((seller) => (
              <TableRow key={seller.id} hover>
                <TableCell sx={{ wordBreak: 'break-all' }}>{seller.id}</TableCell>
                <TableCell>{seller.name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        全{sellers.length}件
      </Typography>
    </Box>
  );
}
